/* Lichtgrün — navigation dots for the mobile card sliders (bestsellers, awards). */
(function () {
  function initSlider(track) {
    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) return;
    if (track.dataset.lgDots) return;
    track.dataset.lgDots = '1';

    var wrap = document.createElement('div');
    wrap.className = 'lg-slider-dots';
    var dots = items.map(function (item, idx) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'lg-slider-dot';
      d.setAttribute('aria-label', 'Zu Element ' + (idx + 1));
      d.addEventListener('click', function () {
        var tr = track.getBoundingClientRect();
        var ir = item.getBoundingClientRect();
        var delta = (ir.left + ir.width / 2) - (tr.left + tr.width / 2);
        track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
      });
      wrap.appendChild(d);
      return d;
    });
    track.parentNode.insertBefore(wrap, track.nextSibling);

    var raf;
    function update() {
      var tr = track.getBoundingClientRect();
      var center = tr.left + tr.width / 2;
      var active = 0, best = Infinity;
      items.forEach(function (item, i) {
        var ir = item.getBoundingClientRect();
        var dist = Math.abs((ir.left + ir.width / 2) - center);
        if (dist < best) { best = dist; active = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
    }
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', function () { requestAnimationFrame(update); });
    update();
  }

  function init() {
    document.querySelectorAll('.lg-best__grid, .lg-awards__grid').forEach(initSlider);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
